import request from '@/common/api'
import { HOSTS } from '@/common/utils/env'
import { IBillListRes, IFundFlowTypeItem, IFundFlowsQueryParams, IFundOverview, IFundTransactionListRes } from './types'

/** 账单列表 */
export const fetchBillList = (params: {
  pageNo: number;
  pageSize: number;
}) => request.get<IBillListRes>(`${HOSTS.BASE}/api/entweb/bill/list`, { params })


/** 账单文件下载 */
export const fetchBillDownlad = (params: {
  billFileId: string;
}) => request.get<{fileUrl: string}>(`${HOSTS.BASE}/api/entweb/bill/downloadFile`, { params })


/** 获取资金总览 */
export const fetchFundSummary = (params?: {
  region?: string;
}) => request.get<IFundOverview>(`${HOSTS.BASE}/api/entweb/account/queryFundSummary`, { params })


/** 获取资金变动明细列表 */
export const fetchFundFlows = (params: IFundFlowsQueryParams) =>
  request.get<IFundTransactionListRes>(`${HOSTS.BASE}/api/entweb/account/pageQueryTrace`, { params })


/** 获取变动类型枚举列表 */
export const fetchFundFlowTypes = () =>
  request.get<IFundFlowTypeItem[]>(`${HOSTS.BASE}/api/entweb/account/queryTraceTypes`)


/** 导出资金变动明细 */
export const fetchFundFlowsExport = (params: IFundFlowsQueryParams) =>
  request.post<string>(`${HOSTS.BASE}/api/entweb/importExport/trace/export`, params)

/** 查询导出任务状态 */
export const queryFundFlowsExportStatus = (params: { token: string }) =>
  request.get<{
    code: number;
    message: string;
    errorCount: number;
    successCount: number;
    downLoadUrl: string;
  }>(`${HOSTS.BASE}/api/entweb/importExport/queryStatus`, { params })
